export function appenedChatItem(selectedTab, message, messageHistory) {
  const newMessage = messageHistory.map((item) => {
    if (item.intent === selectedTab) {
      return {
        ...item,
        chat: [...item.chat, message],
      };
    }
    return item;
  });
  return newMessage;
}
